<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE ACUERDOS -->
              <v-card :key="cardAcuerdos" flat v-if="tabSelected == 'Acuerdos'">
                <acuerdos
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></acuerdos>
              </v-card>
              <!-- TAB DE PROGRESO -->
              <v-card :key="cardProgreso" flat v-if="tabSelected == 'Progreso'">
                <progreso-preguntas
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></progreso-preguntas>
              </v-card>
              <!-- TAB REPORTES -->
              <v-card :key="cardReporte" flat v-if="tabSelected == 'Reporte'">
                <reporte-preguntas
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></reporte-preguntas>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Acuerdos from "@/modules/preguntas/views/acuerdos/AcuerdoPreguntas.vue";
import ProgresoPreguntas from "@/modules/preguntas/views/progreso/ProgresoPreguntas.vue";
import ReportePreguntas from "@/modules/preguntas/views/reporte/ReportePreguntas.vue";

export default {
  components: {
    Acuerdos,
    ProgresoPreguntas,
    ReportePreguntas,
  },
  props: {},
  data: () => ({
    proveedor: {},
    tabs: ["Acuerdos", "Progreso", "Reporte"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
    cardAcuerdos: 0,
    cardProgreso: 10,
    cardReporte: 20,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.tabSelected = "Acuerdos";
    this.active_tab = this.tabs.indexOf(this.tabSelected);
  },
  methods: {
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Acuerdos") {
        this.reloadAcuerdos();
      } else if (this.tabSelected == "Progreso") {
        this.reloadProgreso();
      } else if (this.tabSelected == "Reporte") {
        this.reloadReporte();
      }
    },
    reloadAcuerdos() {
      this.cardAcuerdos += 1;
    },
    reloadProgreso() {
      this.cardProgreso += 11;
    },
    reloadReporte() {
      this.cardReporte += 21;
    },
  },
};
</script>
